import type { BackMultiSelect } from './back-multiselect';
import type { IMultiSelectEvenItem } from '../types/global';

function bindResizeHeightMultiSelect() {
    $('[data-role=multiselect]').each(function () {
        const widget = $(this).data('kendoMultiSelect');
        if (!widget) return;
        const list = widget.list;
        const listParent = list.parent();
        const windowHeight = $(window).height() ?? 0;

        widget.bind('open', () => {
            const scrollTop = $(document).scrollTop() ?? 0;

            const posTop = widget.wrapper.offset()?.top ?? 0;
            const posBottom = posTop + 26;

            const maxHeight = Math.max(
                posTop - scrollTop,
                scrollTop + windowHeight - posBottom
            ) - 10;

            list.css('max-height', maxHeight);
            listParent.css('max-height', maxHeight);
        });
    });
}

function msSelectAll() {
    if (this.value().length === 1 && this.value().includes(-1)) {
        const multiselect = this.element.data('kendoMultiSelect');
        const multiselectData = multiselect.dataSource.data();
        let selectedValues = '';
        let strComma = '';
        for (let i = 0; i < multiselectData.length; i++) {
            const item = multiselectData[i];
            selectedValues += strComma + (item.Value?.toString() ? item.Value.toString() : item.IdToString);
            strComma = ',';
        }
        multiselect.value(selectedValues.split(','));
    }
}

function removeIsCatalogItems(e: kendo.ui.MultiSelectDataBoundEvent) {
    e.sender.dataItems().forEach((item: any) => {
        if (item.IsCatalog) {
            e.sender.dataSource.remove(item);
        }
    });
}

/**
 * Для установки значений динмического мультиселекта, которых нет в dataItems
 * */
function updateDynamicMultiSelectItems(control: kendo.ui.MultiSelect, items: any) {
    const backControl = <BackMultiSelect>control;
    const missingItems = items.filter((ticket: { Id: number; }) =>
        backControl.dataItems().filter((item: { Id: number; }) =>
            ticket.Id === item.Id).length === 0);

    if (missingItems.length > 0) {
        const ids = items.map((x: { Id: number; }) => x.Id);
        const filter = {
            field: 'Text',
            operator: 'contains',
            value: ids.join(',')
        };

        backControl.dataSource.filter(filter);
        backControl.listView.setDSFilter(backControl.dataSource.filter());

        setTimeout(() => {
            backControl.value(ids);
        }, 2500);
    }
}

function dynamicMultiSelectFilter(e: kendo.ui.MultiSelectFilteringEvent, comboName: string, additionalParams?: Function) {
    let txt = '';
    if (e.filter && e.filter.filters[0])
        txt = e.filter.filters[0].value;
    else if (comboName) {
        comboName = comboName.replace(/\./g, '_');
        const combo = $(`#${comboName}`).data('kendoMultiSelect');
        if (combo)
            txt = combo.value();
    }

    const result = additionalParams ? additionalParams() : {};
    result.text = txt;
    return result;
}

function dataMultiSelectEvent(dataItem: IMultiSelectEvenItem) {
    /**
     * Значение пункта - Все
     * */
    const valuesAll = [-1, 'Все'];
    const dataValueField = this.options['dataValueField'] as string;
    const key = dataValueField in dataItem ? dataValueField : 'Value';
    const allElements = this.dataSource.data().map((el: IMultiSelectEvenItem) => el[key]);
    const valueSelected = dataItem[key] as number | string;

    const valueUpdate = (newValue: number[]) => {
        const scrollPos = this.ul.parent().scrollTop();

        this.value(newValue);

        if (newValue.length) {
            this.search();
            this.ul.parent().scrollTop(scrollPos);
        }
    };

    return {
        isAllItemSelect: valuesAll.includes(valueSelected),
        allElements,
        valuesAll,
        valueSelected,
        valueUpdate
    };
}

function onMultiSelectSelect(event: kendo.ui.MultiSelectDeselectEvent) {
    const {
        isAllItemSelect,
        allElements,
        valuesAll,
        valueUpdate,
        valueSelected
    } = dataMultiSelectEvent.call(this, event.dataItem);

    const elementsIncludeAll = allElements.some((i: any) => valuesAll.includes(i));
    const tagTemplateId = this.element.data('tag-template-id');
    const excludedTemplates = ['multiselectShowTextTagTemplate2WithoutAll', 'multiselectShowTextTagTemplate4WithoutAll'];

    if (!excludedTemplates.includes(tagTemplateId)) {
        this._maxTotal = elementsIncludeAll ? allElements.length : allElements.length + 1;
    }

    if (isAllItemSelect || (elementsIncludeAll && this.value().length === allElements.length - 2)) {
        const excludeNums = isAllItemSelect ? valuesAll : [valueSelected];
        valueUpdate(allElements.filter((num: number) => !excludeNums.includes(num)));
    }
}

function onMultiSelectDeselect(event: kendo.ui.MultiSelectDeselectEvent) {
    const {
        isAllItemSelect,
        valueSelected,
        valuesAll,
        valueUpdate
    } = dataMultiSelectEvent.call(this, event.dataItem);

    if (isAllItemSelect) {
        valueUpdate([valueSelected]);
    }
    else {
        setTimeout(() => {
            const scrollPos = this.ul.parent().scrollTop();
            const inputValue = event.sender.input.val() as string;
            valueUpdate(this.value().filter((num: number) => !valuesAll.includes(num)));
            if (inputValue) event.sender.search(inputValue);
            this.ul.parent().scrollTop(scrollPos);
        });
    }
}

window.onMultiSelectDeselect = onMultiSelectDeselect;
window.onMultiSelectSelect = onMultiSelectSelect;
window.removeIsCatalogItems = removeIsCatalogItems;
window.updateDynamicMultiSelectItems = updateDynamicMultiSelectItems;
window.bindResizeHeightMultiSelect = bindResizeHeightMultiSelect;
window.msSelectAll = msSelectAll;
window.dynamicMultiSelectFilter = dynamicMultiSelectFilter;